import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        console.log("PermissionsQuickLookController connected")
        const quickLook = document.querySelector("#permissions-quick-look")
        if (quickLook) {
            quickLook.addEventListener("change", this.handleCheckboxChange.bind(this))
        }
    }

    handleCheckboxChange(event) {
        const checkbox = event.target
        if (checkbox.type !== "checkbox") return
        if (checkbox.hasAttribute("data-dashboard-checkbox")) return

        const adminCheckbox = document.querySelector("#is_admin")
        if (adminCheckbox && checkbox.checked) {
            adminCheckbox.checked = true
        }
    }

    async showQuicklook(event) {
        event.preventDefault()
        const memberId = event.currentTarget.dataset.id
        const url = `/schools/setup/roles-permissions/quick-look?member_id=${memberId}`

        console.log("showQuicklook called with memberId:", memberId)

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
                    Accept: "text/vnd.turbo-stream.html"
                }
            })


            if (response.ok) {
                const quickLookElement = document.querySelector("#permissions-quick-look")
                quickLookElement.innerHTML = await response.text()
                quickLookElement.classList.remove("u-hidden")
            } else {
                console.error("Error fetching quick look data:", response)
            }
        } catch (error) {
            console.error("Error fetching quick look data:", error)
        }
    }

    async closeQuicklook(event) {
        event.preventDefault()
        const quickLookElement = document.querySelector("#permissions-quick-look")
        console.log(quickLookElement)
        quickLookElement.classList.add("u-hidden")
    }
}